<template>
  <transition name="fade">
    <div v-show="visible" class="camera-trap-img">
      <div class="modal-head">
        <div class="modal-subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>

        <div class="modal-title">
          <slot name="title">{{ title || '图片管理器' }}</slot>
        </div>

        <div class="modal-control">
          <slot name="tools"></slot>
          <!-- <a ref="download" class="save-picture" :download="filename">
            <el-button
              type="primary"
              class="picture-download tiny"
              @click="download"
            >
              下载图片
            </el-button>
          </a> -->
          <el-button plain slot="tools" @click="download">
            下载
          </el-button>

          <i class="el-icon-refresh-right" @click="setRotate"></i>
          <!-- <i class="el-icon-zoom-in" v-if="scale < max" @click="zoom(max)"></i>
          <i class="el-icon-zoom-out" v-else @click="zoom(min)"></i> -->
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>

      <div class="modal-content" ref="wrap">
        <div v-if="Boolean(msg)" class="text-error">
          {{ msg }}
        </div>

        <div v-else-if="loading" class="modal-button">
          <i class="el-icon-loading"></i>
        </div>

        <div :style="{ transform: `rotate(${realRotate}deg)` }">
          <div
            v-show="!msg && !loading"
            class="model-img-container"
            ref="test"
            :style="{
              transform,
              left: `${move[0]}px`,
              top: `${move[1]}px`
            }"
          >
            <canvas
              id="img"
              ref="img"
              @mousedown="startMove"
              @dblclick="dbZoom"
            ></canvas>

            <div class="insects-rect">
              <div
                class="model-insect"
                v-for="item in labels"
                :key="item.id"
                :style="insectStyle(item, iw, ih)"
              >
                <div class="model-insect__name">
                  {{ item.category }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="insects-tb"
          :style="{
            right: `calc(50% - (${cw}px / 2 + 140px))`,
            ['max-height']: `${ch}px`
          }"
        >
          <div class="insects-tb-row" v-for="ins in insects" :key="ins.id">
            <span>{{ ins.name }}</span>
            <span>{{ ins.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import path from 'path'
import { getInfo } from '@/service/telemetry'

const COE = 1 // 缩放系数
const MAX = 4 // 缩放最大倍数
const MIN = 0.1 // 缩放最小倍数

export default {
  name: 'ModalPic',
  props: {
    src: String,
    id: [String, Number],
    title: String,
    subtitle: String,
    insects: Array
  },
  data() {
    return {
      loading: true,
      scale: 1, // 默认缩放比例
      max: MAX,
      min: MIN,
      support: 'onwheel',
      downPoint: [0, 0],
      prevMove: [0, 0],
      move: [0, 0],
      msg: null,
      rotate: 0,
      cw: 1024, // 图片容器 宽
      ch: 768, // 图片容器 高
      iw: 1024, // 图片容器 宽
      ih: 768, // 图片容器 高
      visible: true,
      initScale: 1,
      minScale: 0.14,
      labels: []
    }
  },
  computed: {
    isIE() {
      //取得浏览器的userAgent字符串
      const userAgent = navigator.userAgent
      //判断是否IE浏览器
      return (
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      )
    },
    transform() {
      const { scale } = this
      return `scale(${scale},${scale})`
    },
    realRotate() {
      return this.rotate
    }
  },
  mounted() {
    this.loadImg()
  },
  methods: {
    async loadImg() {
      const img = new Image()
      img.src = this.src
      let [{ data = {} }] = await Promise.all([
        this.id ? getInfo(this.id) : [{}],
        new Promise(resolve => {
          img.onload = () => {
            const iw = img.naturalWidth
            const ih = img.naturalHeight
            const ow = this.$refs.wrap.offsetWidth
            const oh = this.$refs.wrap.offsetHeight

            const mw = Math.floor((ow / iw) * 10000) / 10000
            const mh = Math.floor((oh / ih) * 10000) / 10000
            this.initScale = Math.min(mw, mh)
            this.scale = Math.min(mw, mh)
            this.min = Math.min(mw, mh)
            this.cw = iw * this.min
            this.ch = ih * this.min
            this.iw = iw
            this.ih = ih

            this.drawImage(img)
            resolve()
          }
        })
      ])

      this.labels = data.insects || []
      this.onLoad({ target: img })
    },
    insectStyle(item, iw, ih) {
      const width = Math.max(item.tailPositionX - item.headPositionX, 0.005)
      const height = Math.max(item.tailPositionY - item.headPositionY, 0.005)
      const x = item.headPositionX * iw
      const y = item.headPositionY * ih
      return {
        width: `${width * 100}%`,
        height: `${height * 100}%`,
        transform: `translate(${x}px, ${y}px)`
      }
    },
    drawImage(img) {
      const canvas = this.$refs.img
      const ctx = canvas.getContext('2d')

      canvas.width = img.width
      canvas.height = img.height
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      this.getSupport()
    },
    getSupport() {
      this.support =
        'onwheel' in document.createElement('div')
          ? 'wheel'
          : document.onmousewheel !== undefined
          ? 'mousewheel'
          : 'DOMMouseScroll'

      this.$refs.img.addEventListener(this.support, this.zoomPic, {
        passive: false
      })

      // 按 Esc 键退出
      window.addEventListener('keyup', this.keyListener)
    },
    close() {
      this.visible = false
      window.removeEventListener(this.support, this.zoomPic)
      window.removeEventListener('keyup', this.keyListener)
      this.$nextTick(function() {
        if (typeof this.onClose === 'function') {
          this.onClose()
        }
      })
    },
    zoom(scale, px = 0, py = 0) {
      if (scale === this.min) {
        this.move = [0, 0]
        this.prevMove = [0, 0]
      } else {
        const [x, y] = this.move
        const { clientHeight: h, clientWidth: w } = this.$refs.test
        const ox = w / 2 - px
        const oy = h / 2 - py

        const left = ox * scale - ox * this.scale + x
        const top = oy * scale - oy * this.scale + y
        this.prevMove = [left, top]
        this.move = [left, top]
      }
      this.scale = scale
    },
    zoomPic(e) {
      e.preventDefault()
      let change = e.deltaY || e.wheelDelta

      // FireFox
      change = navigator.userAgent.indexOf('Firefox') > 0 ? change * 30 : change

      // 修复ie的滚动缩放
      if (this.isIE) {
        change = -change
      }

      // num > 0: 缩小，num < 0: 放大
      const num = (COE * change) / 1024
      let scale = +(this.scale - num).toFixed(2)

      if (scale > MAX) scale = MAX
      if (scale < this.min) scale = this.min

      const px = e.offsetX
      const py = e.offsetY
      this.zoom(scale, px, py)
    },
    dbZoom(e) {
      const scale = this.scale === this.max ? this.min : this.max
      const px = e.offsetX
      const py = e.offsetY
      this.zoom(scale, px, py)
    },
    startMove(e) {
      if (e.button !== 0) return
      e.preventDefault()
      // 开始移动
      this.downPoint = [
        e.clientX ? e.clientX : e.touches[0].clientX,
        e.clientY ? e.clientY : e.touches[0].clientY
      ]
      window.addEventListener('mousemove', this.moveImg)
      window.addEventListener('mouseup', this.moveEnd)
    },
    moveImg(e) {
      e.preventDefault()
      const [prevX, prevY] = this.prevMove
      const nowX = Math.max(0, e.clientX)
      const nowY = Math.max(0, e.clientY)

      const rotPi = (this.realRotate / 180) * Math.PI
      const sin = Math.sin(rotPi)
      const cos = Math.cos(rotPi)
      const dx = nowX - this.downPoint[0]
      const dy = nowY - this.downPoint[1]
      const left = cos * dx + sin * dy + prevX
      const top = cos * dy - sin * dx + prevY

      this.move = [left, top]
    },
    moveEnd() {
      this.prevMove = this.move.slice()
      window.removeEventListener('mousemove', this.moveImg)
      window.removeEventListener('mouseup', this.leaveImg)
    },
    setRotate() {
      this.rotate = (this.rotate + 90) % 360
    },
    keyListener(evt) {
      // 按键 ESC
      if (evt.keyCode === 27) {
        this.close()
      }
    },
    onLoad(e) {
      this.loading = false
      this.$emit('on-load', e)
    },
    download() {
      let link = document.createElement('a')
      link.setAttribute('download', path.basename(this.src))
      link.href = this.src
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.camera-trap-img {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2004;
  .modal-head {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 0 40px;
    background-color: rgb(10, 10, 10);
    .modal-control {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        cursor: pointer;
        line-height: 60px;
        font-size: 1.5rem;
        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
    }
    .modal-title,
    .modal-subtitle {
      font-size: 1.5rem;
      color: #fff;
      line-height: 60px;
    }
  }
  .modal-content {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 60px);
    background-color: rgba(10, 10, 10, 0.7);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    img {
      width: 100%;
    }
    .modal-button {
      z-index: 3;
      position: absolute;
      width: 4rem;
      height: 4rem;
      font-size: 2rem;
      color: #fff;
      background-color: transparent;
      border-width: 2px;
      &:active {
        background-color: #606266;
      }
      &:hover {
        color: #409eff;
      }
    }
    .modal-button.is-disabled {
      &:active {
        background-color: transparent;
      }
      &:hover {
        color: #fff;
      }
    }
    .model-img-container {
      z-index: 2;
      position: relative;
      user-select: none;
      overflow: hidden;
    }
    .insects-rect {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      user-select: none;
      pointer-events: none;
    }
    .model-insect {
      position: absolute;
      border: 2px solid red;
    }
  }
  .insects-tb {
    background: gray;
    position: absolute;
    // right: 0;
    top: 0;
    user-select: none;
    width: 140px;
    // height: 100px;
    overflow: auto;
    // border-top: 1px solid #909399;
    // border-bottom: 1px solid #909399;
    color: #000;
    .el-button:focus {
      color: red;
      background: #67c23a;
    }
    .el-button:hover {
      background: #67c23a;
    }
  }
  .insects-tb-row {
    cursor: pointer;
    padding: 8px;
    padding-left: 20px;
    color: #f1f1f1;
    font-size: 14px;
    border-bottom: 1px solid #909399;
    display: flex;
    justify-content: space-between;
  }
}
</style>
